export default __webpack_public_path__ + "static/ArgentCF-Bold-c1071552e0d60317a1822cc99636a25e.woff2";